import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
    state:{
        //存放的键值对就是所要管理的状态
        userName:'',
        password:'',
        engineerId:'',
        sectionId:'',
        workAreaId:'',
        mixplantId:'',
        mixplantName:'',
        introduction:"",
        Participation:"",
        construction:"",
        supervisor:"",
        Design:"",
        mixplantOpen: false,
        fronCourOpen: false,
        seIds:""
    },
    mutations: {
        updataUserName(state,item) {
			state.userName = item
        },
        updataSeIds(state,item) {
			state.seIds = item
        },
        updataPassword(state,item) {
			state.password = item
        },
		updataEngineerId(state,item) {
			state.engineerId = item
        },
        updataSectionId(state,item) {
			state.sectionId = item
        },
        updataWorkAreaId(state,item) {
			state.workAreaId = item
        },
        updataMixplantId(state,item) {
			state.mixplantId = item
        },
        updataMixplantName(state,item) {
			state.mixplantName = item
        },
        updataIntroduction(state,item) {
			state.introduction = item
        },
        updataParticipation(state,item) {
			state.Participation = item
        },
        updataConstruction(state,item) {
			state.construction = item
        },
        updataSupervisor(state,item) {
			state.supervisor = item
        },
        updataDesign(state,item) {
			state.Design = item
        },
        updataMixplantOpen(state,item) {
			state.mixplantOpen = item
        },
        updataFronCourOpen(state,item) {
			state.fronCourOpen = item
        },
	}
})

export default store


// WEBPACK FOOTER //
// ./src/store/store.js